import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import HtmlParser from 'react-html-parser';
import Swal from 'sweetalert2';
import { buildingContractModelGet, } from '../../models/buildings/buildingContract';
import {
    buildingContractShowDetails, charactersRemainingGet, dataTableLanguaje, buttonProcessGet, globalSettings, processEvaluateGet, responseGet, sendMessageCloseCurrentWindowAsync,
    dateTimeFormatGlobalSet, styles, languageObjGet, isUndNullEmp, awaitDelay, LoadingSection
} from '../../helpers/settings';
import { buildingModelGet } from '../../models/buildings/building';
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'BuildingContracts';

const {app, labels, messages, } = globalSettings;
const {backend, } = app;

export default function BuildingContracts({
    $ = {},
    auth = {},
    dtId = '',
    rowIndex = 0,
    showModal = false,
    setShowModal = () => { },
    type = 0,
    building = buildingModelGet({}),
    contracts = [],
    setContracts = () => { },
    contractsDt = [],
    setContractsDt = () => { },
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result = {};
    let dataObj = {};
    let headerObj = {};
    const [contractValues, setContractValues] = useState({
        id: '',
        description: '',
        rowIndex: 0,
        type: 0,
    });

    const [isEditDelete] = useState(!isUndNullEmp({ data: type, subMethod: currentMethod, })?.result && type >= 0 && type <= 1 ?
        true : false
    );
    //const dtFontSize = 14;
    const commentMaxLength = 250;
    const [commentRemaining, setCommentRemaining] = useState('');
    const [showLoadingContract, setShowLoadingContract] = useState(true);
    const controls = {
        buttons: {
            save: {
                className: 'btn btn-outline-warning btn-sm mx-1',
                id: 'btnModalContractSave',
            },
            new: {
                className: 'btn btn-outline-success btn-sm',
                id: 'btnModalContractNew',
            },
            back: {
                className: 'btn btn-outline-success btn-sm',
                id: 'btnModalContractBack',
            },
            close: {
                className: 'close btn-danger fas fa-window-close',
                id: 'btnModalContractClose',
            },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            contracts: {
                inputs: {
                    search: {
                        id: `${dtId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtId}_length select`,
                        className: '',
                    },
                },
            },
        },
        icons: {
            save: {
                id: 'iconModalContratcSave',
                className: globalSettings?.icons?.save,
            },
            new: {
                id: 'iconModalContratcNew',
                className: globalSettings?.icons?.fileAltFar,
            },
            back: {
                id: 'iconModalContratcBack',
                className: globalSettings?.icons?.arrowAltCircleLeft,
            },
        },
        inputs: {
            code: {
                id: 'inputModalContractCode',
                className: 'form-control bg-transparent text-black',
            },
            dateStart: {
                id: 'inputModalContractDateStart',
                className: 'form-control datetimepicker-input',
            },
            dateEnd: {
                id: 'inputModalContractDateEnd',
                className: 'form-control datetimepicker-input',
            },
            invoice: {
                id: 'inputModalContractInvoice',
                className: 'form-control bg-transparent',
            },
            controlNumber: {
                id: 'inputModalContractControlNumber',
                className: 'form-control bg-transparent',
            },
            remark: {
                id: 'inputModalContractControlRemark',
                className: 'form-control',
            },
        },
        spinners: {
            new: {
                id: 'spModalContractNew',
                className: '',
            },
            save: {
                id: 'spModalContractSave',
                className: '',
            },
            back: {
                id: 'spModalContractBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion variables

    //#region contract
    const [contract, setContract] = useState(buildingContractModelGet({}));
    const dateStartId = 'contractDateStart';
    //const dateStartInputId = 'contractDateStartInput';
    const dateEndId = 'contractDateEnd';
    //const dateEndInputId = 'contractDateEndInput';
    const [dateStartError, setDateStartError] = useState('');
    const [dateEndError, setDateEndError] = useState('');
    const [invoiceError, setInvoiceError] = useState('');
    const [controlNumberError, setControlNumberError] = useState('');
    const [remarkError, setRemarkError] = useState('');
    //#endregion contract

    //#region contract (methods)
    const addEditDetailsDeleteGetAsync = async ({ e = {}, id = '', description = '', rowIndex = 0, processType_ = 0, subMethod = '', }) => {
        const currentMethod = 'addEditDetailsDeleteGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let msgText = '';
            let swalProperties = {};
            let contractLocal = buildingContractModelGet({});
            //#endregion variables

            //#region error default set
            response = errorsDefaultSet({ subMethod: currentMethod, });

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion error default set

            switch (processType_) {
                case 0:
                    controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                    break;
                case 1:
                    setShowLoadingContract(true);
                    controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                    break;
                case 2:
                    setShowLoadingContract(true);
                    break;
                default:
                    break;
            }

            //#region initialize
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            contractLocal = buildingContractModelGet({
                buildingId: building?.id,
                contractId: building?.contractId,
                userId: auth?.user?.uid,
            });
            //#endregion initialize

            //#region process
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBuildingContracts}/${id}`,
            };

            //#region data get (contract)
            if (processType_ >= 1) {
                result = await axios?.get(
                    headerObj?.url,
                    headerObj,
                );

                response = result?.data;

                if (!response?.isSuccess || response?.isWarning) {
                    setShowLoadingContract(false);
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                contractLocal = response?.result || buildingContractModelGet({});
            }
            //#endregion data get (contract)

            switch (processType_) {
                case -1:
                    //#region old code
                    //#region show message
                    // msgText = `${labels?.contract?.[languageObj?.id]}: <b>${description}</b><br/>`;
                    // msgText += `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`;

                    // swalProperties = {
                    //     icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                    //     title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                    //     html: msgText,
                    //     //html: `${localMsgText}<br/>${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                    //     timer: null,
                    //     confirmButtonColor: globalSettings?.colors?.warningColorExp,
                    //     confirmButtonText: labels?.yes?.[languageObj?.id],
                    //     showCancelButton: true,
                    //     cancelButtonColor: globalSettings?.colors?.successColorExp,
                    //     cancelButtonText: labels?.no?.[languageObj?.id],
                    //     didOpen: () => {
                    //         Swal.hideLoading();
                    //     },
                    // };

                    // const { isConfirmed, } = await Swal.fire(swalProperties);
                    //#endregion show message

                    //#region delete data
                    // if (isConfirmed) {
                    //     sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

                    //     setContractValues({ id, description, rowIndex, type: processType_ });

                    //     //#region delete data
                    //     headerObj.url = `${backend?.url}${backend?.urlApiV1}${backend?.urlBuildingContracts}/${id}`;
                    //     result = await axios.delete(
                    //         headerObj?.url,
                    //         headerObj,
                    //     );

                    //     response = result.data;

                    //     if (!response?.isSuccess || response?.isWarning) {
                    //         await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
                    //         return response;
                    //     }

                    //     $(`#${dtId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
                    //     //#endregion delete data
                    // } else {
                    //     return;
                    // }
                    //#endregion delete data
                    //#endregion old code

                    //#region show message
                    let msgTextObj = {
                        //one: `${labels?.elevator?.[languageObj?.id]}: <b>${description}</b><br/>`,
                        //two: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                        one: `${labels?.contract?.[languageObj?.id]}: <b>${description}</b><br/>`,
                        two: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                    };

                    swalProperties = {
                        icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                        title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                        html: `${msgTextObj?.one}${msgTextObj?.two}`,
                        timer: null,
                        backdrop: true,
                        confirmButtonColor: globalSettings?.colors?.warningColorExp,
                        confirmButtonText: labels?.yes?.[languageObj?.id],
                        showCancelButton: true, //!Swal.isLoading(), //true,
                        cancelButtonColor: globalSettings?.colors?.successColorExp,
                        cancelButtonText: labels?.no?.[languageObj?.id],
                        showLoaderOnConfirm: true,
                        didOpen: () => {
                            Swal.hideLoading();
                        },
                        preConfirm: async () => {
                            try {
                                Swal.getCancelButton().hidden = true;
                                Swal?.update({
                                    icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                                    title: `${messages?.processing?.[languageObj?.id]}...`,
                                    html: msgTextObj?.one,
                                    showConfirmButton: false,
                                });

                                //#region delete data (contract)
                                setContractValues({ id, description, rowIndex, type: processType_ });

                                headerObj.url = `${backend?.url}${backend?.urlApiV1}${backend?.urlBuildingContracts}/${id}`;
                                result = await axios.delete(
                                    headerObj?.url,
                                    headerObj,
                                );

                                response = result?.data;

                                if (!response?.isSuccess || response?.isWarning) {
                                    //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                                    await sendMessageCloseCurrentWindowAsync({
                                        msgType: response?.msgType,
                                        msgText: (isUndNullEmp({ data: response?.msgTextHtml, subMethod: currentMethod })?.result ? response?.msgText : response?.msgTextHtml),
                                        closeWindow: false,
                                        urlGoTo: response?.urlGoTo,
                                        auth: auth,
                                        isLogout: false,
                                        languageId: languageObj?.id,
                                    });
                                    return;
                                }
                                //#endregion delete data (contract)

                                //#region delete dataTable (contract)
                                $(`#${dtId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);

                                setContract(contractLocal)
                                setContractValues({ id: '', description: '', rowIndex: 0, type: 0 });

                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                });

                                //#region old code
                                // //Swal?.hideLoading();
                                // Swal?.update({
                                //     icon: globalSettings?.react?.sweetAlert2?.icons?.success,
                                //     title: globalSettings?.react?.sweetAlert2?.icons?.success,
                                //     html: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                                //     confirmButtonColor: globalSettings?.colors?.successColorExp,
                                //     showConfirmButton: true,
                                //     allowOutsideClick: true,
                                // });

                                // Swal?.hideLoading();
                                // await awaitDelay({ delayTimer: globalSettings?.timers?.tenSeconds, });
                                //#endregion old code
                                //#endregion delete dataTable (contract)
                            } catch (ex) {
                                //#region Error
                                response.isSuccess = false;
                                response.msgType = -1;
                                response.msgText = `Method: ${currentMethod}<br/>`;
                                response.msgText += `Error: ${ex?.message}`;
                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: response?.msgText,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                });
                                //#endregion Error
                            }
                        },
                        allowOutsideClick: () => !Swal.isLoading(),
                    };

                    Swal.fire(swalProperties);
                    //#endregion show message
                    break;
                case 0:
                    //#region error default set
                    response = errorsDefaultSet({ subMethod: currentMethod, });
                    if (!response?.isSuccess || response?.isWarning) {
                        controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return response;
                    }
                    //#endregion error default set

                    //#region DateTime in controls
                    response = dateInControlSet({
                        date: new Date(),
                        dateStart: {},
                        dateEnd: {},
                        processType_: 1,
                        subMethod: currentMethod,
                    });

                    if (!response?.isSuccess || response?.isWarning) {
                        controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return response;
                    }
                    //#endregion DateTime in controls
                    break;
                case 1:
                    //#region data get (contract)
                    //#region old code
                    // //result = await axios?.get(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlBuildingContracts}/${id}`, headerObj);
                    // result = await axios?.get(`${backend?.url}${backend?.urlApiV1}${backend?.urlBuildingContracts}/${id}`, headerObj);
                    // response = result.data;

                    // if (!response?.isSuccess || response?.isWarning) {
                    //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
                    //     return;
                    // }

                    // localContract = response.result;
                    //#endregion old code

                    response = dateInControlSet({
                        date: {},
                        dateStart: contractLocal?.dateStart,
                        dateEnd: contractLocal?.dateEnd,
                        processType_: 1,
                        subMethod: currentMethod,
                    });

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoadingContract(false);
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return response;
                    }
                    //#endregion data get (contract)
                    break;
                case 2:
                    response = buildingContractShowDetails({
                        contract: contractLocal,
                        auth: auth,
                        showInfoAudit: isEditDelete,
                        languageObj: languageObj,
                        subMethod: currentMethod,
                    });

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoadingContract(false);
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    msgText = response?.result;

                    swalProperties = {
                        //icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                        title: labels?.contract?.[languageObj?.id],
                        html: msgText,
                        timer: null,
                        confirmButtonColor: globalSettings?.colors?.successColorExp,
                        confirmButtonText: 'Ok',
                        //showCancelButton: true,
                        //cancelButtonColor: globalSettings?.colors?.successColorExp,
                        //cancelButtonText: labels?.no?.[languageObj?.id],
                        didOpen: () => {
                            Swal.hideLoading();
                        },
                    };

                    Swal.fire(swalProperties);
                    setShowLoadingContract(false);
                    return;
                //break;
                default:
                    break;
            }

            if (processType_ !== -1) {
                setContract(contractLocal);
                setContractValues({ id, description, rowIndex, type: processType_ });

                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                if (processType_ !== 0) {
                    setShowLoadingContract(false);
                }
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else {
                //#region old code
                // setContract(contractLocal)
                // setContractValues({ id: '', description: '', rowIndex: 0, type: 0 });
                // await sendMessageCloseCurrentWindowAsync({
                //     msgType: 0,
                //     msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                //     closeWindow: false,
                //     urlGoTo: response?.urlGoTo,
                //     auth: auth,
                //     isLogout: false,
                //     languageId: languageObj?.id,
                //     subMethod: currentMethod,
                // });
                //#endregion old code
            }
            //#endregion process

            //#region set comment remaining
            if (processType_ !== -1) {
                setCommentRemaining(
                    charactersRemainingGet({
                        text: contractLocal?.remark,
                        maxLength: commentMaxLength,
                        msgText: `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                        subMethod: currentMethod,
                    })?.result
                );
            }
            //#endregion set comment remaining
        } catch (ex) {
            setShowLoadingContract(false);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
        return response;
    }

    const addEditPostAsync = async ({ e = {}, id = '', description = '', rowIndex = 0, processType_ = 0, subMethod = '', }) => {
        const currentMethod = 'addEditPostAsync';
        let response = responseGet();
        try {
            //#region variables
            let contractDtLocal = [];
            let contractLocal = buildingContractModelGet({});
            //#endregion variables

            //#region initialize
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }
            //#endregion initialize

            //#region error default set
            response = errorsDefaultSet({ subMethod: currentMethod, });

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion error default set

            //#region data set / validate form data
            if (contractValues?.type !== -1) {
                response = dataSet({ subMethod: currentMethod });

                if (!response?.isSuccess || response?.isWarning) {
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                response = await formDataValidateAsync({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return;
                }
            }
            //#endregion data set / validate form data

            setShowLoadingContract(true);
            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region process
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                contract: contract,
                languageId: languageObj?.id,
                url: '',
            };

            switch (contractValues.type) {
                case -1:
                    break;
                case 0:
                    //#region add data (buildingContract)
                    dataObj.url = `${backend?.url}${backend?.urlApiV1}${backend?.urlBuildingContracts}/`;
                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj,
                    );

                    response = result?.data;

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoadingContract(false);
                        controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    contractLocal = response?.result;
                    //#endregion add data (buildingContract)
                    break;
                case 1:
                    //#region update data (buildingContract)
                    dataObj.url = `${backend?.url}${backend?.urlApiV1}${backend?.urlBuildingContracts}/${contract.id}`;
                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj
                    );

                    response = result?.data;

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoadingContract(false);
                        controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    contractLocal = response?.result;
                    //#endregion update data (buildingContract)
                    break;
                default: break;
            }
            //#endregion process

            //#region set dataTable
            if (!contractValues?.type !== -1) {
                contractDtLocal = [
                    dateTimeFormatGlobalSet({
                        date: contractLocal?.dateStart,
                        type: globalSettings?.react?.tempusDominus?.format?.date?.ymdTwo,
                        format: 24,
                        addTime: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                    contractLocal?.subContractId,
                    //dateTimeFormatGlobalSet(contractLocal?.dateStart, globalSettings?.react?.tempusDominus?.format?.date?.dmy, 0, false).result,
                    dateTimeFormatGlobalSet({
                        date: contractLocal?.dateStart,
                        type: languageObj?.format?.date?.f1,
                        //format: languageObj?.format?.time?.type,
                        format: 0,
                        addTime: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                    //dateTimeFormatGlobalSet(contractLocal?.dateEnd, globalSettings?.react?.tempusDominus?.format?.date?.dmy, 0, false).result,
                    dateTimeFormatGlobalSet({
                        date: contractLocal?.dateEnd,
                        type: languageObj?.format?.date?.f1,
                        //format: languageObj?.format?.time?.type,
                        format: 0,
                        addTime: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                    buttonProcessGet({
                        id: contractLocal?.id,
                        description: contractLocal?.subContractId,
                        showDetails: true,
                        labelDetails: labels?.detail?.[languageObj?.id],
                        enabledDetails: true,
                        showEdit: true,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: processEvaluateGet({
                            object: contractLocal,
                            property: labels?.process?.en?.toLowerCase(),
                            process: labels?.edit?.en?.toLowerCase(),
                            subMethod: currentMethod,
                        })?.result,
                        showDelete: true,
                        labelDelete: labels?.delete?.[languageObj?.id],
                        enabledDelete: processEvaluateGet({
                            object: contractLocal,
                            property: labels?.process?.en?.toLowerCase(),
                            process: labels?.delete?.en?.toLowerCase(),
                            subMethod: currentMethod,
                        })?.result,
                        processButtons: [],
                        subMethod: currentMethod,
                    })?.result,
                ];
            }

            switch (contractValues?.type) {
                // case -1:
                //     $(`#${dtId}`)?.DataTable()?.row(contractValues.rowIndex)?.remove()?.draw(true);
                //     break;
                case 0:
                    $(`#${dtId}`)?.DataTable()?.row?.add(contractDtLocal)?.draw(true);
                    break;
                case 1:
                    $(`#${dtId}`)?.DataTable()?.row(contractValues?.rowIndex).data(contractDtLocal)?.draw(true);
                    break;
                default:
                    break;
            }
            //#endregion set dataTable

            //#region set value
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response = await addEditDetailsDeleteGetAsync({
                e: {},
                id: '',
                description: '',
                rowIndex: 0,
                processType_: 0,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoadingContract(false);
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                return response;
            }
            //#endregion set value

            setContractValues({ id: '', description: '', rowIndex: 0, type: 0 });
            setShowLoadingContract(false);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            setShowLoadingContract(false);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion contract (methods)

    //#region methods (others)
    const defaultValueSetAsync = async ({ isModalClose = false, subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                //#region old code
                //response = await localSetErrosDefaultAsync();
                // if (!response?.isSuccess || response?.isWarning) {
                //     return;
                // }
                //#endregion old code
                setShowModal(!isModalClose);
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTablesSet = ({ subMethod = '', }) => {
        const currentMethod = 'dataTablesSet';
        let response = responseGet();
        try {
            //#region variables
            //let dataLocal = ``;
            //#endregion variables

            //#region process
            $(`#${dtId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.date?.[languageObj?.id], visible: false, width: '0%', },
                    { title: labels?.code?.[languageObj?.id], visible: true, width: '15%', },
                    // {
                    //     title: labels?.code?.[languageObj?.id], visible: true, width: '15%',
                    //     render: function (data, type, row) {
                    //         dataLocal = `<span style='font-size:${dtFontSize}px'>${data}</span>`;
                    //         return dataLocal;
                    //     },
                    // },
                    { title: labels?.start?.[languageObj?.id], visible: true, width: '40%', },
                    // {
                    //     title: labels?.start?.[languageObj?.id], visible: true, width: '40%',
                    //     render: function (data, type, row) {
                    //         dataLocal = `<span style='font-size:${dtFontSize}px'>${data}</span>`;
                    //         return dataLocal;
                    //     },
                    // },
                    { title: labels?.end?.[languageObj?.id], visible: true, width: '40%', },
                    // {
                    //     title: labels?.end?.[languageObj?.id], visible: true, width: '40%',
                    //     render: function (data, type, row) {
                    //         dataLocal = `<span style='font-size:${dtFontSize}px'>${data}</span>`;
                    //         return dataLocal;
                    //     },
                    // },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                autoWidth: false,
                data: [],
                destroy: true,
                info: false,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                //lengthChange: true,
                lengthChange: false,
                pageLength: 5,
                order: [[0, 'desc']],
                responsive: true,
                searching: true,
                //}).buttons().container().appendTo(`#${dtApartmentsId}_wrapper .col-md-6:eq(0)`);
            });
            //#endregion process
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const queryCodeSet = ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSet';
        let response = responseGet();
        try {
            //#region variables
            let rowIndex = 0;
            let dtRowIndex = 0;
            let method = '';
            let id = '';
            let description = '';
            //#endregion variables

            $(`#${dtId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                e.preventDefault();
                rowIndex = $(`#${dtId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    method = e?.target?.attributes?.method?.value || '';
                    id = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'edit':
                            addEditDetailsDeleteGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType_: 1, subMethod: currentMethod, });
                            break;
                        case 'details':
                            addEditDetailsDeleteGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType_: 2, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            addEditDetailsDeleteGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType_: -1, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const dateInControlSet = ({ date = {}, dateStart = {}, dateEnd = {}, processType_ = 0, subMethod = '', }) => {
        const currentMethod = 'dateInControlSet';
        let response = responseGet();
        try {
            //#region initialize
            //#region old code
            //let dateTimeObj.start = '';
            //let dateTimeObj.end = '';
            //const dateTimeObj?.format = globalSettings?.react?.tempusDominus?.format?.date?.dmy;
            //const dateTimeObj?.formatTwo = globalSettings?.react?.tempusDominus?.format?.date?.DDMMYYYY;
            //const dateTimeObj?.timeFormatTwo = globalSettings?.react?.tempusDominus?.format?.time?.hhmmA;
            //#endregion old code
            const dateTimeObj = {
                date: '',
                format: languageObj?.format?.date?.f1,
                //formatTwo: `${languageObj?.format?.date?.f11} ${languageObj?.format?.time?.picker?.hhmm}`,
                formatTwo: languageObj?.format?.date?.f11,
                timeFormat: languageObj?.format?.time?.type,
                timeFormatTwo: languageObj?.format?.time?.f3,
                start: '',
                end: '',
            };
            //#endregion initialize

            //#region dateStart data set
            if (!isUndNullEmp({ data: dateStart, subMethod: currentMethod, })?.result) {
                dateTimeObj.start = dateTimeFormatGlobalSet({
                    date: dateStart,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.timeFormat,
                    addTime: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else {
                dateTimeObj.start = dateTimeFormatGlobalSet({
                    date: date,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.timeFormat,
                    addTime: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }
            //#endregion dateStart data set

            //#region dateEnd data set
            if (!isUndNullEmp({ data: dateEnd, subMethod: currentMethod, })?.result) {
                dateTimeObj.end = dateTimeFormatGlobalSet({
                    date: dateEnd,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.timeFormat,
                    addTime: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else {
                dateTimeObj.end = dateTimeFormatGlobalSet({
                    date: date,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.timeFormat,
                    addTime: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }
            //#endregion dateEnd data set

            //#region process
            if (processType_ === 0) {
                $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                    icons: globalSettings?.react?.tempusDominus?.icons,
                    buttons: globalSettings?.react?.tempusDominus?.buttons,
                    tooltips: globalSettings?.react?.tempusDominus?.tooltips,
                    locale: languageObj?.id,
                });

                $(`#${dateStartId}`)?.datetimepicker({
                    date: moment(`${dateTimeObj.start}`, `${dateTimeObj?.formatTwo} ${dateTimeObj?.timeFormatTwo}`),
                    default: false,
                    timepicker: false,
                    format: `${dateTimeObj?.formatTwo} ${dateTimeObj?.timeFormatTwo}`,
                });

                $(`#${dateEndId}`)?.datetimepicker({
                    date: moment(`${dateTimeObj.end}`, `${dateTimeObj?.formatTwo} ${dateTimeObj?.timeFormatTwo}`),
                    default: false,
                    timepicker: false,
                    format: `${dateTimeObj?.formatTwo} ${dateTimeObj?.timeFormatTwo}`,
                });
            } else if (processType_ === 1) {
                $(`#${dateStartId}`)?.datetimepicker('date', moment(`${dateTimeObj.start}`, `${dateTimeObj?.formatTwo} ${dateTimeObj?.timeFormatTwo}`));
                $(`#${dateEndId}`)?.datetimepicker('date', moment(`${dateTimeObj.end}`, `${dateTimeObj?.formatTwo} ${dateTimeObj?.timeFormatTwo}`));
            }
            //#endregion process
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const dataSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataSetAsync';
        let response = responseGet();
        try {
            //#region set dataTable
            response = dataTablesSet({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                setShowModal(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            $(`#${dtId}`)?.DataTable()?.rows?.add(contractsDt)?.draw(true);
            //#endregion set dataTable

            //#region set queryCode
            response = queryCodeSet({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                setShowModal(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion set queryCode

            //#region dateTime in control sets
            response = dateInControlSet({
                date: new Date(),
                dateStart: {},
                dateEnd: {},
                processType_: 0,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) {
                setShowModal(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            //#endregion dateTime in control sets

            //#region data set
            response = await addEditDetailsDeleteGetAsync({
                e: null,
                id: '',
                description: '',
                rowIndex: 0,
                processType_: 0,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });
            }
            //#endregion data set

            setShowLoadingContract(false);
        } catch (ex) {
            setShowModal(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
        return response;
    }

    const formDataSetAsync = async ({ property = '', value = '', subMethod = '', }) => {
        const currentMethod = 'formDataSetAsync';
        let response = responseGet();
        try {
            setContract({ ...contract, [property]: value, });

            //#region set comment remaining
            if (property === 'remark') {
                setCommentRemaining(
                    charactersRemainingGet({
                        text: value,
                        maxLength: commentMaxLength,
                        msgText: `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                        subMethod: currentMethod,
                    })?.result
                );
            }
            //#endregion set comment remaining
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const dataSet = ({ subMethod = '', }) => {
        const currentMethod = 'dataSet';
        let response = responseGet();
        try {
            //const dateTimeObj?.start = $(`#${dateStartId}`)?.datetimepicker('date')?._d;
            //const dateTimeObj?.end = $(`#${dateEndId}`)?.datetimepicker('date')?._d;
            const dateTimeObj = {
                start: $(`#${dateStartId}`)?.datetimepicker('date')?._d,
                end: $(`#${dateEndId}`)?.datetimepicker('date')?._d,
            };

            contract.dateStart = !isUndNullEmp({ data: dateTimeObj?.start, subMethod: currentMethod, })?.result ? new Date(dateTimeObj?.start).toISOString() : contract?.dateStart;
            contract.dateEnd = !isUndNullEmp({ data: dateTimeObj?.end, subMethod: currentMethod, })?.result ? new Date(dateTimeObj?.end).toISOString() : contract?.dateEnd;
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            //#region variables
            //const dateTimeObj?.start = $(`#${controls?.inputs?.dateStart?.id}`)?.val();
            //const dateTimeObj?.end = $(`#${controls?.inputs?.dateEnd?.id}`)?.val();

            const dateTimeObj = {
                start: $(`#${controls?.inputs?.dateStart?.id}`).val(),
                end: $(`#${controls?.inputs?.dateEnd?.id}`).val(),
            };
            //#endregion variables

            //#region process
            if (isUndNullEmp({ data: contract?.invoice, subMethod: currentMethod, })?.result) {
                setInvoiceError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
            if (isUndNullEmp({ data: contract?.controlNumber, subMethod: currentMethod, })?.result) {
                setControlNumberError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
            if (isUndNullEmp({ data: contract?.remark, subMethod: currentMethod, })?.result) {
                setRemarkError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
            if (isUndNullEmp({ data: dateTimeObj?.start, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: contract?.dateStart, subMethod: currentMethod, })?.result) {
                setDateStartError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
            if (isUndNullEmp({ data: dateTimeObj?.end, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: contract?.dateEnd, subMethod: currentMethod, })?.result) {
                setDateEndError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
            if (moment(new Date(contract?.dateStart).toUTCString()).isSame(new Date(contract?.dateEnd).toUTCString())) {
                setDateStartError(messages?.theseFieldsCanNotBeTheSame?.[languageObj?.id]);
                setDateEndError(messages?.theseFieldsCanNotBeTheSame?.[languageObj?.id]);
                response.isWarning = true;
            }
            if (moment(new Date(contract?.dateEnd).toUTCString()).isBefore(new Date(contract?.dateStart).toUTCString())) {
                setDateStartError(messages?.dateToMustBeGreaterThanDateFrom?.[languageObj?.id]);
                setDateEndError(messages?.dateToMustBeGreaterThanDateFrom?.[languageObj?.id]);
                response.isWarning = true;
            }
            //#endregion process
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errorsDefaultSet = ({ subMethod = '', }) => {
        const currentMethod = 'errorsDefaultSet';
        let response = responseGet();
        try {
            setRemarkError('');
            setInvoiceError('');
            setDateEndError('');
            setDateStartError('');
            setControlNumberError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const goToBackAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'goToBackAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            controlsStatusSet({ processType: 3, subMethod: currentMethod, });

            //#region methods
            response = errorsDefaultSet({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            //#endregion methods
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.removeClass();

                    $(`#${controls?.icons?.new?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.new?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.new?.id}`)?.removeClass();

                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.removeClass();

                    $(`#${controls?.buttons?.close?.id}`)?.removeClass();

                    $(`#${controls?.icons?.save?.id}`)?.addClass(controls?.icons?.save?.className);
                    $(`#${controls?.buttons?.save?.id}`)?.addClass(controls?.buttons?.save?.className);
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(controls?.spinners?.save?.className);

                    $(`#${controls?.icons?.new?.id}`)?.addClass(controls?.icons?.new?.className);
                    $(`#${controls?.buttons?.new?.id}`)?.addClass(controls?.buttons?.new?.className);
                    $(`#${controls?.spinners?.new?.id}`)?.addClass(controls?.spinners?.new?.className);

                    $(`#${controls?.icons?.back?.id}`)?.addClass(controls?.icons?.back?.className);
                    $(`#${controls?.buttons?.back?.id}`)?.addClass(controls?.buttons?.back?.className);
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(controls?.spinners?.back?.className);

                    $(`#${controls?.buttons?.close?.id}`)?.addClass(controls?.buttons?.close?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.new?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.new?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 3:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 4:
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.code?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.dateStart?.id}`)?.attr('disabled', (processType !== 0));
            $(`#${controls?.inputs?.dateEnd?.id}`)?.attr('disabled', (processType !== 0));
            $(`#${controls?.inputs?.invoice?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.controlNumber?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.remark?.id}`)?.attr('readOnly', (processType !== 0));
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            $(`#${controls?.dataTables?.contracts?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.contracts?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.new?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataSetAsync({ subMethod: 'form - onLoad', });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <Modal backdrop='static' show={showModal} scrollable={isEditDelete} onHide={(e) => goToBackAsync({ e: e, subMethod: 'modal - form', })}>
            <Modal.Header>
                <Modal.Title><img alt={labels?.contract?.[languageObj?.id]}
                    src={globalSettings?.images?.buildingContract}
                    style={styles?.cardHeaderLogo}></img> - {labels?.contract?.[languageObj?.id]} ({type === 0 ?
                        labels?.add?.[languageObj?.id]?.toLowerCase() : type === 1 ?
                            labels?.edit?.[languageObj?.id]?.toLowerCase() :
                            labels?.detail?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={(e) => goToBackAsync({ e: e, subMethod: 'modal - header', })}>
                </button>
            </Modal.Header>
            <Modal.Body>
                <div className='row text-muted'>
                    <div className='col-md-4'>
                        {labels?.building?.[languageObj?.id]}:
                    </div>
                    <div className='col-md-8'>
                        <b>{building?.description || ''}</b>
                    </div>
                </div>

                <div className='row text-muted'>
                    <div className='col-md-4'>
                        {labels?.contract?.[languageObj?.id]}:
                    </div>
                    <div className='col-md-8'>
                        <b>{building?.contractId || ''}</b>
                    </div>
                    {/* <hr /> */}
                </div>

                <hr />

                {isEditDelete ?
                    <form>
                        {/* <LoadingSection alt='loadingSection'
                            className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                            showText={true}
                            text={messages?.processing?.[languageObj?.id]}
                            height={25}
                            //hidden={!showLoading}
                            hidden={false}
                            width={25}
                            languageId={languageObj?.id}
                            subMethod={currentMethod} /> */}
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='form-group'>
                                    <div className='row text-muted'>
                                        <div className='form-group'>
                                            <label>{contractValues.type === 0 ? labels?.add?.[languageObj?.id] : labels?.edit?.[languageObj?.id]}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='col-md-6'>
                                <div className='form-group'>
                                    <div className='input-group mb-3'>
                                        <input id={controls?.inputs?.code?.id}
                                            className={controls?.inputs?.code?.className}
                                            //className='form-control bg-transparent text-black'
                                            placeholder={labels?.code?.[languageObj?.id]}
                                            readOnly
                                            tooltip='tooltip'
                                            title={labels?.code?.[languageObj?.id]}
                                            value={contract?.subContractId || ''}
                                        />
                                        <div className='input-group-append'>
                                            <div className='input-group-text'>
                                                <span className={globalSettings?.icons?.fasFa?.tags} />
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(contractSubContractIdError)}</div> */}
                                </div>
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='form-group'>
                                    <div className='input-group mb-3'>
                                        <div id={dateStartId} className='input-group date'
                                            data-target-input='nearest'>
                                            <input id={controls?.inputs?.dateStart?.id}
                                                //autoFocus
                                                className={controls?.inputs?.dateStart?.className}
                                                //className='form-control datetimepicker-input'
                                                data-target={`#${dateStartId}`}
                                                data-toggle='datetimepicker'
                                                //onFocus={() => setDateStartError('')}
                                                onFocus={() => {
                                                    setDateEndError('');
                                                    setDateStartError('');
                                                }}
                                                placeholder={labels?.startDate?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.startDate?.[languageObj?.id]}
                                                type='text' />
                                            <div className='input-group-append' data-target={`#${dateStartId}`} data-toggle='datetimepicker'>
                                                <div className='input-group-text'><i className={globalSettings?.icons?.calendarAlt}></i></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(dateStartError)}</div>
                                </div>
                            </div>

                            <div className='col-md-6'>
                                <div className='form-group'>
                                    <div className='input-group mb-3'>
                                        <div id={dateEndId} className='input-group date'
                                            data-target-input='nearest'>
                                            <input id={controls?.inputs?.dateEnd?.id}
                                                //className='form-control datetimepicker-input'
                                                className={controls?.inputs?.dateEnd?.className}
                                                data-target={`#${dateEndId}`}
                                                data-toggle='datetimepicker'
                                                //onFocus={() => setDateEndError('')}
                                                onFocus={() => {
                                                    setDateEndError('');
                                                    setDateStartError('');
                                                }}
                                                placeholder={labels?.endDate?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.endDate?.[languageObj?.id]}
                                                type='text' />
                                            <div className='input-group-append' data-target={`#${dateEndId}`} data-toggle='datetimepicker'>
                                                <div className='input-group-text'><i className={globalSettings?.icons?.calendarAlt}></i></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(dateEndError)}</div>
                                </div>
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='form-group'>
                                    <div className='input-group mb-3'>
                                        <input id={controls?.inputs?.invoice?.id}
                                            className={controls?.inputs?.invoice?.className}
                                            //className='form-control bg-transparent'
                                            placeholder={labels?.invoice?.[languageObj?.id]}
                                            tooltip='tooltip'
                                            title={labels?.invoice?.[languageObj?.id]}
                                            onChange={(e) => formDataSetAsync({ property: 'invoice', value: e?.target?.value, subMethod: 'input - invoice', })}
                                            onFocus={() => setInvoiceError('')}
                                            value={contract?.invoice || ''}
                                        />
                                        <div className='input-group-append'>
                                            <div className='input-group-text'>
                                                <span className={globalSettings?.icons?.fileInvoice} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(invoiceError)}</div>
                                </div>
                            </div>

                            <div className='col-md-6'>
                                <div className='form-group'>
                                    <div className='input-group mb-3'>
                                        <input id={controls?.inputs?.controlNumber?.id}
                                            className={controls?.inputs?.controlNumber?.className}
                                            //className='form-control bg-transparent'
                                            placeholder={labels?.controlNumber?.[languageObj?.id]}
                                            tooltip='tooltip'
                                            title={labels?.controlNumber?.[languageObj?.id]}
                                            onChange={(e) => formDataSetAsync({ property: 'controlNumber', value: e?.target?.value, subMethod: 'input - controlNumber', })}
                                            onFocus={() => setControlNumberError('')}
                                            value={contract?.controlNumber || ''}
                                        />
                                        <div className='input-group-append'>
                                            <div className='input-group-text'>
                                                <span className={globalSettings?.icons?.fileAltFar} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(controlNumberError)}</div>
                                </div>
                            </div>

                        </div>

                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='input-group mb-3'>
                                    <textarea id={controls?.inputs?.remark?.id}
                                        className={controls?.inputs?.remark?.className}
                                        onChange={(e) => formDataSetAsync({ property: 'remark', value: e?.target?.value, subMethod: 'input - remark', })}
                                        onFocus={() => setRemarkError('')}
                                        placeholder={labels?.remark?.[languageObj?.id]}
                                        rows={2}
                                        maxLength={commentMaxLength}
                                        tooltip='tooltip'
                                        title={labels?.remark?.[languageObj?.id]}
                                        value={contract?.remark || ''}>
                                    </textarea>
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={globalSettings?.icons?.edit} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles.labelMsgInfo}>{HtmlParser(commentRemaining)}</div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(remarkError)}</div>
                            </div>
                        </div>

                        <div className='form-group text-right'>
                            <button id={controls?.buttons?.save?.id}
                                className={controls?.buttons?.save?.className}
                                //className='btn btn-outline-warning btn-sm mx-1'
                                disabled={!isEditDelete}
                                onClick={(e) => addEditPostAsync({ e: e, id: '', description: '', rowIndex: 0, processType_: contractValues?.type, subMethod: 'btn -save', })}
                                title={labels?.save?.[languageObj?.id]}>
                                <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                            </button>
                            <button id={controls?.buttons?.new?.id}
                                className={controls?.buttons?.new?.className}
                                disabled={!isEditDelete}
                                onClick={(e) => addEditDetailsDeleteGetAsync({ e: e, id: '', description: '', rowIndex: 0, processType_: 0, subMethod: 'btn - new', })}
                                title={labels?.new?.[languageObj?.id]}>
                                <i id={controls?.icons?.new?.id} className={controls?.icons?.new?.className} /> <span id={controls?.spinners?.new?.id} className='' aria-hidden='true'></span>
                            </button>
                        </div>
                        <hr />
                    </form>
                    :
                    <></>
                }

                <div className='row'>
                    <div className='col-md-12'>
                        <LoadingSection alt='loadingSection'
                            className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                            showText={true}
                            text={messages?.processing?.[languageObj?.id]}
                            height={25}
                            hidden={!showLoadingContract}
                            width={25}
                            languageId={languageObj?.id}
                            subMethod={currentMethod} />
                        <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                            <table id={dtId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered} />
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button id={controls?.buttons?.back?.id}
                    className={controls?.buttons?.back?.className}
                    onClick={(e) => goToBackAsync({ e: e, subMethod: 'btn - close', })}
                    title={labels?.close?.[languageObj?.id]}>
                    <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                </button>
            </Modal.Footer>
        </Modal>
    )
}